/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_JulyInputs */

const he_month_july = /** @type {(inputs: Month_JulyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יולי`)
};

const en_month_july = /** @type {(inputs: Month_JulyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`July`)
};

/**
* | output |
* | --- |
* | "July" |
*
* @param {Month_JulyInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_july = /** @type {((inputs?: Month_JulyInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_JulyInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_july(inputs)
	return en_month_july(inputs)
});